export const invertColor = (
  hex: string,
  baseColor: string,
  altColor: string
): string => {
  const testedHex = hex.slice(1)
  if (testedHex.length !== 6) {
    throw new Error('Invalid HEX color.')
  }
  const r = Number.parseInt(testedHex.slice(0, 2), 16)
  const g = Number.parseInt(testedHex.slice(2, 4), 16)
  const b = Number.parseInt(testedHex.slice(4, 6), 16)
  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? baseColor : altColor
}
